<template>
  <div id="material-kit">
    <div :class="{ 'nav-open': NavbarStore.showNavbar }">
      <router-view name="header" />
      <div>
        <router-view />
      </div>
      <router-view name="footer" />

      <modal v-if="classicModal" @close="classicModalHide">
        <template slot="header">
          <h4 class="modal-title">Modal Title</h4>
          <md-button
            class="md-simple md-just-icon md-round modal-default-button"
            @click="classicModalHide"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>
        </template>

        <template slot="footer">
          <md-button class="md-simple">Nice Button</md-button>
          <md-button class="md-danger md-simple" @click="classicModalHide">Close</md-button>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import { Modal } from "@/components";
export default {
  components: {
    Modal
  },
  data() {
    return {
      classicModal: false
    };
  },
  methods: {
    classicModalHide() {
      this.classicModal = false;
    }
  }
};
</script>

<style>
.cursor_pointer{
  cursor : pointer;
}

.md-card.md-theme-default.bar-breadcrumb {
  margin-top: 30px;
  box-shadow: none;
  background-color: #f5f5f5;
}

.md-card.md-theme-default.bar-breadcrumb .md-card-content {
  padding: 10px 15px;
}

.md-ripple > span.md-list-item-text {
  width: initial;
  height: initial;
  overflow: initial;
  position: initial;
  left: initial;
  z-index: initial;
}

.md-button {
  line-height: initial !important;
}

.md-numeric .md-table-head-label,
.md-numeric.md-table-head:last-child .md-table-head-label {
  padding-right: 12px;
}

.md-numeric.md-table-cell:last-child .md-table-cell-container {
  /* display: initial; */
}

.container-flex_center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.md-table-head.cell-center {
  text-align: center;
}

.md-table-head.cell-center .md-table-head-label {
  padding-left: 0px;
  padding-right: 0px;
}

.breadcrumb-slash {
  padding: 0px 5px;
}

.container-numeric {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

@media (max-width: 960px) {
  .md-large-hide.md-show-on-mobile {
    display: initial;
  }
}
</style>
